import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import navlogo from "../assets/nav-logo.png";
import homepage from "../assets/homepage.webp";
import whyus from "../assets/why-us.webp";
import { fetchSheetData } from "../services/googleSheetService";


function HomePage() {
  const [activeTab, setActiveTab] = useState("Coconut-Based Vegan Ice Cream");
  const [activeSection, setActiveSection] = useState("home");
  const [isOpen, setIsOpen] = useState(false);
  const [categoryDescriptions, setCategoryDescriptions] = useState({});
  const [productsData, setProductsData] = useState({});

  // Track active section while scrolling
  useEffect(() => {
    const sections = [
      "home",
      "mission",
      "values",
      "unique",
      "products",
      "why",
      "contact",
    ];
    const handleScroll = () => {
      const scrollPos = window.scrollY + 100;
      for (let section of sections) {
        const el = document.getElementById(section);
        if (
          el &&
          scrollPos >= el.offsetTop &&
          scrollPos < el.offsetTop + el.offsetHeight
        ) {
          setActiveSection(section);
        }
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

    useEffect(() => {
    const SHEET_ID = "1CIjp0LFgtb_8FTxf8_KasBTTs7aazS7N5AIiK4dWtmw";

    const getData = async () => {
      const { categoryDescriptions, productsData } = await fetchSheetData(SHEET_ID);
      console.log("products", categoryDescriptions, productsData)
      setCategoryDescriptions(categoryDescriptions);
      setProductsData(productsData);
    };

    getData();
  }, []);

  return (
    <>
      <div className="min-h-screen bg-white font-poppins">
        {/* Navbar */}
        <nav className="fixed top-0 left-0 w-full bg-white shadow-md z-50">
          <div className="max-w-7xl mx-auto px-6 py-4 flex justify-between items-center">
            {/* Logo */}
            {/* <h1 className="text-2xl md:text-3xl font-extrabold text-green-700 tracking-wide">
              Naturals One
            </h1> */}
            <a href="#home">
              {" "}
              <img src={navlogo} className="w-20 rounded-lg" alt="Logo" />
            </a>
            <ul className="hidden md:flex space-x-6 text-gray-800 font-medium">
              {["home", "mission", "values", "products", "unique", "why"].map(
                (link) => (
                  <li key={link}>
                    <a
                      href={`/#${link}`}
                      className={`transition ${
                        activeSection === link
                          ? "text-green-700 font-semibold"
                          : "hover:text-green-600"
                      }`}
                    >
                      {link === "unique"
                        ? "Our's Unique"
                        : link === "why"
                        ? "Why Us"
                        : link.charAt(0).toUpperCase() + link.slice(1)}
                    </a>
                  </li>
                )
              )}

              {/* Contact as Route */}
              <li>
                <Link
                  to="/contact"
                  className={`transition ${
                    activeSection === "contact"
                      ? "text-green-700 font-semibold"
                      : "hover:text-green-600"
                  }`}
                >
                  Contact
                </Link>
              </li>
            </ul>
            {/* Desktop Button */}
            <a href="#products">
              <button className="hidden md:block bg-gradient-to-r from-green-700 to-green-500 text-white px-5 py-2 rounded-full font-semibold hover:from-green-600 hover:to-green-400 transition shadow-md">
                Shop Now
              </button>
            </a>

            {/* Mobile Hamburger */}
            <div className="md:hidden">
              <button
                onClick={() => setIsOpen(!isOpen)}
                className="text-gray-800 text-2xl"
              >
                {isOpen ? "✕" : "☰"}
              </button>
            </div>
          </div>

          {/* Mobile Menu */}
          {isOpen && (
            <div className="md:hidden bg-white shadow-md px-6 py-4 space-y-4">
              <ul className="space-y-2">
                {[
                  "home",
                  "mission",
                  "values",
                  "unique",
                  "products",
                  "why",
                  "contact",
                ].map((link) => (
                  <li key={link}>
                    <a
                      href={`#${link}`}
                      className={`block transition ${
                        activeSection === link
                          ? "text-green-700 font-semibold"
                          : "hover:text-green-600"
                      }`}
                      onClick={() => setIsOpen(false)}
                    >
                      {link === "unique"
                        ? "What Makes Us Unique"
                        : link === "why"
                        ? "Why Naturals One"
                        : link.charAt(0).toUpperCase() + link.slice(1)}
                    </a>
                  </li>
                ))}
              </ul>
              <a href="#products">
                <button className="w-full bg-gradient-to-r from-green-700 to-green-500 text-white px-5 py-2 rounded-full font-semibold hover:from-green-600 hover:to-green-400 transition shadow-md">
                  Shop Now
                </button>
              </a>
            </div>
          )}
        </nav>

        {/* Hero Section */}
        <section
          id="home"
          className="pt-40 pb-32  bg-white relative overflow-hidden w-full"
        >
          <div className="flex flex-col lg:flex-row items-center max-w-7xl mx-auto px-6">
            {/* Left Content */}
            <div className="lg:w-1/2 space-y-10 text-center lg:text-left animate-slide-down relative z-10">
              <h1 className="text-5xl md:text-7xl font-extrabold text-gray-900 leading-tight">
                Discover the{" "}
                <span className="text-green-700">Bright Taste</span> of Nature
              </h1>
              <p className="text-lg md:text-2xl text-gray-700 max-w-xl mx-auto lg:mx-0">
                Refresh your lifestyle with{" "}
                <span className="text-green-800 font-bold">
                  100% organic coconut
                </span>{" "}
                products. Natural, healthy, and crafted with love.
              </p>
              <div className="flex flex-col sm:flex-row sm:space-x-6 space-y-4 sm:space-y-0 justify-center lg:justify-start">
                <a href="#products">
                  <button className="bg-gradient-to-r from-green-700 to-green-500 text-white px-10 py-5 rounded-full font-semibold hover:from-green-600 hover:to-green-400 transition shadow-lg transform hover:scale-105">
                    Explore Products
                  </button>
                </a>
                {/* <button className="bg-green-100 text-green-800 px-10 py-5 rounded-full font-semibold hover:bg-green-200 transition shadow-lg transform hover:scale-105">
                  Watch Video
                </button> */}
              </div>
            </div>

            {/* Right Image */}
            <div className="lg:w-1/2 mt-16 lg:mt-0 flex justify-center relative z-10">
              <div className="relative">
                <img
                  src={whyus}
                  alt="Coconut Products"
                  className="rounded-3xl shadow-2xl w-full max-w-lg md:max-w-xl object-cover h-[400px] transform hover:scale-105 transition"
                />
                {/* Decorative accent shape */}
                <div className="absolute -bottom-6 -left-6 w-full h-full bg-green-100 rounded-3xl -z-10"></div>
              </div>
            </div>
          </div>
        </section>

        {/* Welcome Section */}
        <section id="welcome" className="py-10 bg-white text-center">
          <div className="max-w-4xl mx-auto px-4 sm:px-6">
            <h2 className="text-4xl lg:text-5xl font-extrabold text-green-700 mb-6">
              Welcome to <span className="text-coconut">Naturals One</span>
            </h2>
            <p className="text-lg lg:text-xl text-gray-700 leading-relaxed mb-8">
              Naturals One is an evolving brand dedicated to providing the
              purest organic and natural products for discerning customers.
              Starting with innovative coconut-based vegan ice cream (made with
              coconut milk and coconut milk powder, no dairy) and tender coconut
              water, we set the stage for a platform that celebrates nature’s
              best. Our focus is on quality, sustainability, and holistic
              wellness, guided by the agricultural richness of India’s coconut
              industry.
            </p>
          </div>
        </section>

        <section id="mission" className="py-24 bg-green-50">
          <div className="container mx-auto px-6">
            {/* Section Header */}
            <div className="text-center mb-20">
              <h2 className="text-4xl lg:text-5xl font-extrabold text-green-700 mb-4">
                Mission & Vision
              </h2>
              <p className="text-lg text-gray-700 max-w-3xl mx-auto">
                Our commitment to quality and sustainability drives everything
                we do at Naturals One
              </p>
            </div>

            {/* Cards */}
            <div className="flex flex-col lg:flex-row gap-10">
              {/* Mission Card */}
              <div className="lg:w-1/2 bg-white rounded-3xl p-8 shadow-lg hover:shadow-2xl transition">
                <div className="flex items-center mb-6">
                  <div className="bg-green-600 text-white w-12 h-12 rounded-full flex items-center justify-center text-xl shadow-md">
                    <i className="fas fa-bullseye"></i>
                  </div>
                  <h3 className="text-3xl font-bold text-green-700 ml-4">
                    Our Mission
                  </h3>
                </div>
                <p className="text-gray-700 text-lg leading-relaxed">
                  To inspire healthy living by creating and curating a
                  world-class portfolio of organic and natural products.
                  Naturals One is passionately committed to delivering wholesome
                  plant-based alternatives — starting with coconut specialties
                  and expanding to agro-based products such as organic honey,
                  aloe vera, herbal teas, and a full range of wellness
                  solutions. We endeavour to build a sustainable future, empower
                  farmers, and foster trust among health-conscious communities.
                </p>
                <div className="mt-6 flex items-center text-secondary font-semibold">
                  <i className="fas fa-leaf mr-2"></i> 100% Natural Ingredients
                </div>
              </div>

              {/* Vision Card */}
              <div className="lg:w-1/2 bg-white rounded-3xl p-8 shadow-lg hover:shadow-2xl transition">
                <div className="flex items-center mb-6">
                  <div className="bg-green-100 text-green-600 w-12 h-12 rounded-full flex items-center justify-center text-xl shadow-md">
                    <i className="fas fa-eye"></i>
                  </div>
                  <h3 className="text-3xl font-bold text-green-700 ml-4">
                    Our Vision
                  </h3>
                </div>
                <p className="text-gray-700 text-lg leading-relaxed mb-4">
                  To redefine refreshment with natural, plant-based innovations
                  that inspire wellness and delight for every generation. We
                  envision a world where healthy living is accessible,
                  delicious, and sustainable for everyone. By embracing ethical
                  sourcing, environmentally friendly practices, and continuous
                  product innovation, Naturals One aims to empower communities,
                  support farmers, and set new standards in quality and taste.
                </p>
                <div className="mt-6 flex items-center text-secondary font-semibold">
                  <i className="fas fa-seedling mr-2"></i> Sustainable & Ethical
                  Practices
                </div>
              </div>
            </div>
          </div>
        </section>

        <section id="values" className="py-24 bg-white relative">
          <div className="container mx-auto px-6 relative z-10">
            {/* Section Header */}
            <div className="text-center mb-20">
              <h2 className="text-4xl lg:text-5xl font-extrabold text-green-700 mb-4">
                Our Values
              </h2>
              <p className="text-lg lg:text-xl text-gray-700 max-w-3xl mx-auto">
                The principles that guide our actions and define our brand
              </p>
            </div>

            {/* Value Cards */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
              {[
                {
                  title: "Natural & Pure",
                  icon: "fa-leaf",
                  iconBg: "bg-green-600",
                  iconColor: "text-white",
                  desc: "Embrace natural ingredients without compromise. Every product is carefully crafted from organic and minimally processed sources, ensuring purity, authenticity, and the true goodness of nature.",
                },
                {
                  title: "Sustainability",
                  icon: "fa-recycle",
                  iconBg: "bg-emerald-700",
                  iconColor: "text-white",
                  desc: "Support wellness, sustainability, and conscious choices. We prioritize eco-friendly sourcing, minimal waste, and environmentally responsible packaging in every step of production.",
                },
                {
                  title: "Health Focused",
                  icon: "fa-heart",
                  iconBg: "bg-rose-500",
                  iconColor: "text-white",
                  desc: "Innovate for better taste and better health. Our offerings are designed to deliver nutritional benefits without sacrificing flavor, helping you maintain a balanced and wholesome lifestyle.",
                },
                {
                  title: "Community",
                  icon: "fa-users",
                  iconBg: "bg-lime-700",
                  iconColor: "text-white",
                  desc: "Deliver quality with honesty and transparency. We work closely with farmers and local communities to ensure fair practices, empowering people while sharing the benefits of natural wellness.",
                },
              ].map((val, idx) => (
                <div
                  key={idx}
                  className="bg-white rounded-3xl p-8 text-center shadow-lg hover:shadow-2xl transform hover:-translate-y-2 hover:scale-105 transition-all duration-300"
                >
                  <div
                    className={`w-16 h-16 rounded-full flex items-center justify-center text-2xl mx-auto mb-6 ${val.iconBg} shadow-md ${val.iconColor}`}
                  >
                    <i className={`fas ${val.icon}`}></i>
                  </div>
                  <h3 className="text-xl font-bold text-green-700 mb-4">
                    {val.title}
                  </h3>
                  <p className="text-gray-700 text-base">{val.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* <section
          id="products"
          className="py-24 bg-accent-10 relative overflow-hidden"
        >
          <div className="absolute -top-20 -left-20 w-72 h-72 rounded-full bg-green-500 opacity-20 animate-float"></div>
          <div className="absolute -bottom-32 -right-32 w-96 h-96 rounded-full bg-green-400 opacity-15 animate-float"></div>

          <div className="container mx-auto px-6 relative z-10">
            <div className="text-center mb-16">
              <h2 className="text-4xl lg:text-5xl font-extrabold text-green-700 mb-4">
                Our Products
              </h2>
              <p className="text-lg lg:text-xl text-gray-700 max-w-3xl mx-auto">
                Explore our diverse range of coconut-based delights. Switch tabs
                to view products by category.
              </p>
            </div>

            <div className="flex flex-wrap justify-center gap-4 mb-12">
              {Object.keys(productsData).map((tab) => (
                <button
                  key={tab}
                  className={`px-6 py-3 rounded-full font-semibold transition whitespace-nowrap ${
                    activeTab === tab
                      ? "bg-green-700 text-white shadow-lg"
                      : "bg-white text-green-700 border border-gray-300 hover:bg-green-500 hover:text-white"
                  }`}
                  onClick={() => setActiveTab(tab)}
                >
                  {tab}
                </button>
              ))}
            </div>

            <div className="max-w-4xl mx-auto text-center mb-12">
              <h3 className="text-2xl font-bold text-green-700 mb-4">
                {activeTab}
              </h3>
              <p className="text-gray-700 text-lg leading-relaxed">
                {categoryDescriptions[activeTab]}
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-12 max-w-5xl mx-auto">
              {productsData[activeTab].map((product, idx) => (
                <div
                  key={idx}
                  className="bg-white rounded-3xl shadow-lg hover:shadow-2xl transition p-6 flex flex-col md:flex-row gap-6 items-center"
                >
                  <div className="flex-shrink-0">
                    <img
                      src={product.img}
                      alt={product.name}
                      className="w-48 h-48 md:w-56 md:h-56 object-cover rounded-2xl shadow-lg transform hover:scale-105 transition"
                    />
                  </div>

                  <div className="flex-1">
                    <h3 className="text-2xl font-bold text-green-700 mb-3">
                      {product.name}
                    </h3>
                    <p className="text-gray-700 text-lg leading-relaxed">
                      {product.desc}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section> */}

<section id="products" className="py-24 bg-accent-10 relative overflow-hidden">
  {/* Decorative Floating Shapes */}
  <div className="absolute -top-20 -left-20 w-72 h-72 rounded-full bg-green-500 opacity-20 animate-float"></div>
  <div className="absolute -bottom-32 -right-32 w-96 h-96 rounded-full bg-green-400 opacity-15 animate-float"></div>

  <div className="container mx-auto px-6 relative z-10">
    {/* Section Header */}
    <div className="text-center mb-16">
      <h2 className="text-4xl lg:text-5xl font-extrabold text-green-700 mb-4">
        Our Products
      </h2>
      <p className="text-lg lg:text-xl text-gray-700 max-w-3xl mx-auto">
        Explore our diverse range of coconut-based delights. Switch tabs
        to view products by category.
      </p>
    </div>

    {/* Tabs - Responsive */}
    <div className="flex flex-wrap justify-center gap-4 mb-12">
      {Object.keys(productsData || {}).length > 0 ? (
        Object.keys(productsData).map((tab) => (
          <button
            key={tab}
            className={`px-6 py-3 rounded-full font-semibold transition whitespace-nowrap ${
              activeTab === tab
                ? "bg-green-700 text-white shadow-lg"
                : "bg-white text-green-700 border border-gray-300 hover:bg-green-500 hover:text-white"
            }`}
            onClick={() => setActiveTab(tab)}
          >
            {tab}
          </button>
        ))
      ) : (
        <p className="text-gray-500">Loading categories...</p>
      )}
    </div>

    {/* Category Description */}
 {/* Category Description */}
{categoryDescriptions && Object.keys(categoryDescriptions).length > 0 && activeTab && (
  <div className="max-w-4xl mx-auto text-center mb-12">
    <h3 className="text-2xl font-bold text-green-700 mb-4">{activeTab}</h3>
    <p className="text-gray-700 text-lg leading-relaxed">
      {categoryDescriptions[activeTab] || "Description coming soon..."}
    </p>
  </div>
)}

    {/* Product Cards */}
{productsData[activeTab] && productsData[activeTab].length > 0 ? (
  <div className="grid grid-cols-1 md:grid-cols-2 gap-12 max-w-5xl mx-auto">
    {productsData[activeTab].map((product, idx) => (
      <div
        key={idx}
        className="bg-white rounded-3xl shadow-lg hover:shadow-2xl transition p-6 flex flex-col md:flex-row items-center gap-6"
      >
        {/* Image */}
        <div className="flex-shrink-0 flex justify-center md:justify-start w-full md:w-1/2">
          <img
            src={product.img}
            alt={product.name}
            className="w-48 h-48 md:w-56 md:h-56 object-cover rounded-2xl shadow-lg transform hover:scale-105 transition"
          />
        </div>

        {/* Content */}
        <div className="flex-1 flex flex-col justify-between w-full md:w-1/2">
          <div className="text-center md:text-left">
            <h3 className="text-2xl font-bold text-green-700 mb-3">
              {product.name}
            </h3>
            <p className="text-gray-700 text-lg leading-relaxed">
              {product.desc}
            </p>
          </div>

          {/* Coming Soon Button */}
          <div className="mt-4 flex justify-center md:justify-start">
            <button
              disabled
              className="w-full md:w-auto bg-gray-400 text-white py-2 px-6 rounded-xl font-semibold cursor-not-allowed"
            >
              Available Soon
            </button>
          </div>
        </div>
      </div>
    ))}
  </div>
) : (
  <p className="text-center text-gray-500">Loading products...</p>
)}


  </div>
</section>

        <section id="unique" className="py-24 bg-green-50">
          <div className="container mx-auto px-6">
            {/* Section Header */}
            <div className="text-center mb-16">
              <h2 className="text-4xl lg:text-5xl font-extrabold text-green-700 mb-4">
                What Makes Us Unique
              </h2>
              <p className="text-lg lg:text-xl text-gray-700 max-w-3xl mx-auto">
                Naturals One offers:
              </p>
            </div>

            {/* Feature Cards */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 max-w-6xl mx-auto">
              {/* Card 1 */}
              <div className="bg-white rounded-3xl shadow-lg p-8 flex flex-col items-center text-center hover:shadow-2xl transition transform hover:-translate-y-2">
                <div className="bg-pink-200 text-pink-600 w-16 h-16 rounded-full flex items-center justify-center text-2xl mb-4 shadow-md">
                  <i className="fas fa-ice-cream"></i>
                </div>
                <h4 className="text-xl font-bold text-green-700 mb-2">
                  Guilt-Free Ice Cream
                </h4>
                <p className="text-gray-700 text-sm md:text-base">
                  Dairy-free, hydrating, naturally sweet coconut water ice
                  cream.
                </p>
              </div>

              {/* Card 2 */}
              <div className="bg-white rounded-3xl shadow-lg p-8 flex flex-col items-center text-center hover:shadow-2xl transition transform hover:-translate-y-2">
                <div className="bg-green-200 text-green-700 w-16 h-16 rounded-full flex items-center justify-center text-2xl mb-4 shadow-md">
                  <i className="fas fa-wine-bottle"></i>
                </div>
                <h4 className="text-xl font-bold text-green-700 mb-2">
                  Tender Coconut Water
                </h4>
                <p className="text-gray-700 text-sm md:text-base">
                  Pure, electrolyte-rich, conveniently packed for hydration.
                </p>
              </div>

              {/* Card 3 */}
              <div className="bg-white rounded-3xl shadow-lg p-8 flex flex-col items-center text-center hover:shadow-2xl transition transform hover:-translate-y-2">
                <div className="bg-yellow-200 text-yellow-600 w-16 h-16 rounded-full flex items-center justify-center text-2xl mb-4 shadow-md">
                  <i className="fas fa-flask"></i>
                </div>
                <h4 className="text-xl font-bold text-green-700 mb-2">
                  No Artificial Additives
                </h4>
                <p className="text-gray-700 text-sm md:text-base">
                  Products made with a commitment to no artificial flavors,
                  colors, or preservatives.
                </p>
              </div>

              {/* Card 4 */}
              <div className="bg-white rounded-3xl shadow-lg p-8 flex flex-col items-center text-center hover:shadow-2xl transition transform hover:-translate-y-2">
                <div className="bg-emerald-200 text-emerald-700 w-16 h-16 rounded-full flex items-center justify-center text-2xl mb-4 shadow-md">
                  <i className="fas fa-seedling"></i>
                </div>
                <h4 className="text-xl font-bold text-green-700 mb-2">
                  Taste & Health
                </h4>
                <p className="text-gray-700 text-sm md:text-base">
                  A focus on taste, health, and responsible sourcing, delivering
                  deliciousness with every product.
                </p>
              </div>
            </div>
          </div>
        </section>

        <section id="why" className="py-24 bg-white">
          <div className="max-w-7xl mx-auto px-6 flex flex-col lg:flex-row items-center gap-16">
            {/* Left Text Content */}
            <div className="lg:w-1/2 space-y-6">
              <h2 className="text-4xl lg:text-5xl font-extrabold text-green-700">
                Why Naturals One?
              </h2>
              <p className="text-gray-700 text-lg lg:text-xl">
                Naturals One stands out for its pure ingredients, unique product
                blends, and commitment to natural, minimally processed
                refreshment. Each offering is developed for people seeking
                healthy alternatives without compromising on taste or quality.
              </p>

              {/* Key Points Cards */}
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mt-8">
                {/* Pure Ingredients */}
                <div className="bg-white rounded-3xl shadow-lg p-6 flex items-center space-x-4 hover:shadow-2xl transition transform hover:-translate-y-1">
                  <div className="bg-green-600 text-white w-12 h-12 rounded-full flex items-center justify-center text-xl">
                    <i className="fas fa-leaf"></i>
                  </div>
                  <span className="font-semibold text-gray-800">
                    Pure Ingredients
                  </span>
                </div>

                {/* Unique Blends */}
                <div className="bg-white rounded-3xl shadow-lg p-6 flex items-center space-x-4 hover:shadow-2xl transition transform hover:-translate-y-1">
                  <div className="bg-emerald-600 text-white w-12 h-12 rounded-full flex items-center justify-center text-xl">
                    <i className="fas fa-seedling"></i>
                  </div>
                  <span className="font-semibold text-gray-800">
                    Unique Blends
                  </span>
                </div>

                {/* Minimal Processing */}
                <div className="bg-white rounded-3xl shadow-lg p-6 flex items-center space-x-4 hover:shadow-2xl transition transform hover:-translate-y-1">
                  <div className="bg-blue-400 text-white w-12 h-12 rounded-full flex items-center justify-center text-xl">
                    <i className="fas fa-droplet"></i>
                  </div>
                  <span className="font-semibold text-gray-800">
                    Minimal Processing
                  </span>
                </div>

                {/* Healthy Alternatives */}
                <div className="bg-white rounded-3xl shadow-lg p-6 flex items-center space-x-4 hover:shadow-2xl transition transform hover:-translate-y-1">
                  <div className="bg-green-700 text-white w-12 h-12 rounded-full flex items-center justify-center text-xl">
                    <i className="fas fa-spa"></i>
                  </div>
                  <span className="font-semibold text-gray-800">
                    Healthy Alternatives
                  </span>
                </div>
              </div>
            </div>
            {/* Right Image */}
            <div className="lg:w-1/2 flex justify-center relative">
              <img
                src={homepage}
                alt="Naturals One Products"
                className="rounded-3xl shadow-2xl w-full max-w-sm sm:max-w-md lg:max-w-lg transform hover:scale-105 transition h-[300px] sm:h-[400px] object-cover"
              />
              {/* Decorative accent */}
            </div>
          </div>
        </section>

        <footer
          className="bg-green-50 text-gray-800 pt-16 pb-2 border-t border-green-200"
          id="contact"
        >
          <div className="max-w-7xl mx-auto px-6">
            <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
              {/* Brand */}
              <div>
                <div className="flex items-center mb-6">
                  <img src={navlogo} className="w-24 rounded-lg" />
                </div>
                <p className="text-gray-600 leading-relaxed mb-6">
                  Refresh your lifestyle with 100% organic coconut products.
                  Natural, healthy, and crafted with love.
                </p>
                <div className="flex space-x-4">
                  {[
                    {
                      icon: "facebook-f",
                      link: "https://facebook.com",
                    },
                    {
                      icon: "instagram",
                      link: "https://instagram.com",
                    },
                    {
                      icon: "linkedin",
                      link: "https://linkedin.com",
                    },
                  ].map(({ icon, link }) => (
                    <a
                      key={icon}
                      href={link}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="bg-green-100 text-green-700 p-3 rounded-full shadow hover:bg-green-700 hover:text-white transition duration-300 transform hover:scale-110"
                    >
                      <i className={`fab fa-${icon}`}></i>
                    </a>
                  ))}
                </div>
              </div>

              {/* Quick Links */}
              <div>
                <h3 className="text-lg font-bold mb-6 text-green-700">
                  Quick Links
                </h3>
                <ul className="space-y-3 text-gray-700">
                  {[
                    { name: "Home", link: "#home" },
                    { name: "Mission & Vision", link: "#mission" },
                    { name: "Our Values", link: "#values" },
                    { name: "Our Products", link: "#products" },
                    { name: "What Makes Us Unique", link: "#unique" },
                    { name: "Why Naturals One", link: "#why" },
                  ].map((item) => (
                    <li key={item.name}>
                      <a
                        href={item.link}
                        className="hover:text-green-700 transition duration-300"
                      >
                        {item.name}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Products */}
              <div>
                <h3 className="text-lg font-bold mb-6 text-green-700">
                  Products
                </h3>
                <ul className="space-y-3 text-gray-700">
                  {[
                    "Vegan Ice Cream",
                    "Coconut Water",
                    "Tender Coconut Chunks  ",
                    "Naturals One Mineral Water",
                    "CocoCarb-Pure Air Mask"
                  ].map((product) => (
                    <li key={product}>
                      <a
                        href="#products"
                        className="hover:text-green-700 transition duration-300"
                      >
                        {product}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Contact */}
              <div>
                <h3 className="text-lg font-bold text-green-700">Contact Us</h3>
                <h3 className="font-bold text-lg text-green-700 mb-4">
                  Naturals One
                </h3>
                <ul className="space-y-4 text-gray-700">
                  <li className="flex items-start">
                    <i className="fas fa-map-marker-alt mr-3 text-green-700 mt-1"></i>
                    <span className="text-gray-700 leading-relaxed">
                      No: 1-A, CRS Estate, Regunathapuram, Kasangadu,
                      Pattukkottai, Thanjavur District, Tamilnadu, India -
                      614613
                    </span>
                  </li>
                  <li className="flex items-center">
                    <i className="fas fa-phone mr-3 text-green-700"></i>
                    <a href="tel:+919962920850" className="hover:underline">
                      +91-9962920850
                    </a>
                  </li>
                  <li className="flex items-center">
                    <i className="fas fa-envelope mr-3 text-green-700"></i>
                    <a
                      href="mailto:info@naturalsone.com"
                      className="hover:underline"
                    >
                      info@naturalsone.com
                    </a>
                  </li>
                </ul>
              </div>
            </div>

            {/* Bottom Bar */}
            <div className="mt-12 border-t border-green-200 pt-6 text-center text-gray-500 text-sm">
              © {new Date().getFullYear()}{" "}
              <span className="font-semibold text-green-700">Naturals One</span>
              . All rights reserved. <br />
              Naturals One: Creating a healthier, more delicious world, one
              coconut at a time
              <br />
              <span className="mt-1 block">
                Developed by{" "}
                <a
                  href="https://alizesoftwareservices.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-green-700 font-semibold hover:underline"
                >
                  Alize Software Services LLP
                </a>
              </span>
            </div>
          </div>
        </footer>
      </div>
    </>
  );
}

export default HomePage;
